import { useTranslation } from "@redotech/redo-i18n";
import { AssignmentTypeOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { AssignmentTypeState } from "@redotech/redo-return-ui/flows/rules/conditions/assignment-type";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";

export const AssignmentTypeDetails = memo(function AssignmentTypeDetails({
  state,
  setState,
}: ConditionTypeDetailsProps<AssignmentTypeState>) {
  const { t } = useTranslation();
  const assignmentOptions = [
    {
      id: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
      type: "text" as const,
      text: t("AI agent assigned"),
      value: AssignmentTypeOption.AI_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
      type: "text" as const,
      text: t("Support agent assigned"),
      value: AssignmentTypeOption.SUPPORT_AGENT_ASSIGNEE,
    },
    {
      id: AssignmentTypeOption.NO_ASSIGNEE,
      type: "text" as const,
      text: t("No assignee"),
      value: AssignmentTypeOption.NO_ASSIGNEE,
    },
  ];

  const selectedAssignment = assignmentOptions.find(
    (option) => option.id === state.assignmentType,
  );

  return (
    <RedoSingleSelectDropdownInput
      label={t("Assignment")}
      options={assignmentOptions}
      optionSelected={({ item }) => {
        setState({
          ...state,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          assignmentType: item.id as typeof state.assignmentType,
        });
      }}
      selectedItem={selectedAssignment}
    />
  );
});
